import { createAction, props } from '@ngrx/store';
import { HostedContentFilterPolicy } from './model';

export const fetchHostedContentFilterPolicy = createAction(
    '[Client/Pwsh/Exo] Fetch Hosted Content Filter Policy',
    props<{ _tenant: string }>(),
);

export const fetchHostedContentFilterPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Fetch Hosted Content Filter Policy Success',
    props<{ _tenant: string; data: HostedContentFilterPolicy[] }>(),
);

export const fetchHostedContentFilterPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Fetch Hosted Content Filter Policy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateExoHostedContentFilterPolicy = createAction(
    '[Client/Pwsh/Exo] Update Hosted Content Filter Policy',
    props<{ _tenant: string; data: Partial<HostedContentFilterPolicy> }>(),
);

export const updateExoHostedContentFilterPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Update Hosted Content Filter Policy Success',
    props<{ _tenant: string; data: HostedContentFilterPolicy }>(),
);

export const updateExoHostedContentFilterPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Update Hosted Content Filter Policy Failure',
    props<{ _tenant: string; error: any }>(),
);
